// extracted by mini-css-extract-plugin
module.exports = {"lastClickedRow":"style__lastClickedRow__9WAiz"};